import React, { useEffect, useState } from "react";
import ReportStageContainer from "../../ContainersManager/ReportStageContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllStagesByReportId,
  GetCurrentStageFromReport,
  SetreportStageGuid,
} from "../../Redux/Reducers/ReportStage/Stages";
import { useParams } from "react-router-dom";
import {
  decryptToken,
  encryptToken,
} from "../../Services/Account/EncryptionParams";
import AllDropDownsAHSF from "../../Components/AllDropDownsAHSF";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";

import { GetReport } from "../../Redux/Reducers/ReportStage/ExchangeDirectCost";
import "./style.css";
import InformationAboutApplication from "../../PagesReportStage/InformationAboutApplication";
import ButtonAHSF from "../../Components/ButtonAHSF";

const ReportSummaryPage = (props) => {
  const reportGuidFromApi = useSelector(
    (state) => state.ExchangeDirectCostReducers.ReportByApp
  );
  const currentStage = useSelector((state) => state.Stages.CurrentStage);
  const dispatch = useDispatch();
  let { reportId } = useParams();
  console.log(currentStage?.pR_ReportsStagesGuid, "ssssdwdwdwdwdwd");

  const state = useSelector((state) => {
    return {
      ReportsStagesDropDownList: state.Stages.ReportsStagesDropDownList,
      loadingReportsStagesDropDownList:
        state.Stages.loadingReportsStagesDropDownList,

      ReportByApp: state.ReportByAppGuidReducers.ReportByApp,
    };
  });
  const [specificOrMulti, setspecificOrMulti] = useState(false);
  const [reportStage, setreportStage] = useState();
  reportId = decryptToken(reportId);
  /////////////////////////////////////////////////////

  useEffect(() => {
    if (props.location == "manager") {
      if (reportGuidFromApi?.pR_ReportsId) {
        dispatch(GetAllStagesByReportId(reportGuidFromApi?.pR_ReportsId));
      }
    }
  }, []);

  // console.log(reportGuidFromApi?.pR_ReportsId, "reportGuidFromApi?.pR_ReportsId");
  

  useEffect(() => {
    if (props.location != "manager") {
      if (reportId) {
        dispatch(GetAllStagesByReportId(reportId));
      }
    }
  }, [reportId]);
  /////////////////////////////////////////////////////

  useEffect(() => {
    if (props.location == "manager") {
      dispatch(GetReport({ aI_ApplicationInformationId: reportId }));
    }
  }, [reportId]);
  /////////////////////////////////////////////////////
  

  useEffect(() => {
    if (props.location == "manager") {
      if (reportGuidFromApi?.pR_ReportsId) {
        dispatch(
          GetCurrentStageFromReport({
            reportGuid: reportGuidFromApi?.pR_ReportsId,
          })
        );
      }
    } else {
      if (reportId) {
        dispatch(GetCurrentStageFromReport({ reportGuid: reportId }));
      }
    }
  }, [reportGuidFromApi?.pR_ReportsId, reportId]);
  /////////////////////////////////////////////////////

  useEffect(() => {
    if (currentStage?.pR_ReportsStagesGuid) {
      setreportStage(currentStage?.pR_ReportsStagesGuid);
      dispatch(SetreportStageGuid(currentStage?.pR_ReportsStagesGuid));
    }
  }, [currentStage?.pR_ReportsStagesGuid]);

  return state.ReportsStagesDropDownList ? (
    <>
      <SharedDiv
        showTitle={true}
        titleName="ملخص التقرير المرحلي" // Arabic for "Marketing Resources and Publications"
        child={[
          <div
            className="summaryInfo"
           
          >
            <AllDropDownsAHSF
              fieldsName="ExStages"
              show={true}
              disabled={false}
              arrayOoptionList={state.ReportsStagesDropDownList}
              KeyText={"stagesName"}
              KeyValue={"pR_ReportsStagesGuid"}
              dropdownType={"normal"}
              onChange={(e) => {
                setreportStage(e.target.value);
                dispatch(SetreportStageGuid(e.target.value));
                // setTechnicalReportNotesList({
                //   ...TechnicalReportNotesList,
                //   pR_NotesTableId: e.target.value,
                // });
              }}
              defaultValue={currentStage?.pR_ReportsStagesGuid}
              //   showValidationMessage={
              //     state.TechnicalReportNotesValidate
              //       ? state.TechnicalReportNotesValidate.includes("noteTable")
              //       : false
              //   }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {  window.location.href.includes("manager") == true?
            <div style={{ justifyItems: "center", padding: "1%" }}>
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  window.open(
                    `/grants/manager/ApplicationInformation/` +
                      encryptToken(
                        localStorage.getItem(
                          "aI_ApplicationInformationId_Manager"
                        )
                      ),
                    "_blank"
                  );
                }}
                disabled={false}
                title={"  عرض معلومات الطلب"}
                text={"عرض معلومات الطلب"}
                show={true}
              />
            </div>
            :""}
          </div>,
        ]}
      />
      <SharedDiv
        showTitle={true}
        titleName="معلومات عن الطلب"
        child={[<InformationAboutApplication />]}
      />
      {reportStage ? (
        <ReportStageContainer
          canEdite={false}
          specificOrMulti={false}
          stageGuid={reportStage}
          reportId={props.location == "manager"?reportGuidFromApi?.pR_ReportsId: reportId}
          location="fromSummary"
        />
      ) : (
        ""
      )}
    </>
  ) : (
    ""
  );
};

export default ReportSummaryPage;
